export default __webpack_public_path__ + "static/media/saving.bg.aed117eb.svg";